"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NavbarHorizontalStyle1Module {
}
exports.NavbarHorizontalStyle1Module = NavbarHorizontalStyle1Module;
